// utils/braze.ts
export class BrazeManager {
  private static initialized = false;

  static initialize(key: string, options: object) {
    if (typeof window === 'undefined' || !window.braze) return;

    try {
      if (!this.initialized) {
        window.braze.initialize(key, options);

        window.braze.automaticallyShowInAppMessages();
        window.braze.openSession();
      }
      this.initialized = true;
    } catch (e) {
      console.error('Braze initialization error:', e);
    }
  }

  // eslint-disable-next-line consistent-return
  static async logEvent({
    eventName,
    isNativeAppBoth,
    isIOS,
    properties,
  }: {
    eventName: string;
    isNativeAppBoth: boolean;
    isIOS: boolean;
    properties?: { [key: string]: string | number | string[] };
  }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      try {
        if (isNativeAppBoth) {
          const params = {
            event_name: eventName,
            event_value: properties,
            event_data: {
              items: {},
            },
          };
          if (isIOS) {
            window.webkit?.messageHandlers?.WckBraze?.postMessage(
              JSON.stringify(params)
            );
            resolve(true);
          } else {
            window?.WckBraze?.WckBraze(JSON.stringify(params));
            resolve(true);
          }
        } else {
          const res = await window?.braze?.logCustomEvent(
            eventName,
            properties
          );
          // eslint-disable-next-line @typescript-eslint/await-thenable
          window.braze?.requestImmediateDataFlush();
          setTimeout(() => {
            resolve(true);
          }, 0);
        }
      } catch (e) {
        console.error('Braze logEvent error:', e);
        resolve(false);
      }
    });
  }
}
